<script lang="ts" setup> 
    import '../../css/choice.css';
    import {NoTzDate} from "../lib/DateUtils";
    import {getScreenInfo} from '../lib/ChoiceUserConfiguration';
    import {AppScreens,PrivilegeType} from '../Enums/ChoiceEnums';
    import {DisplayStyle, IconTypes} from "../Enums/UiEnums";
    import {onMounted,ref} from 'vue';
    import Icon from "../components/Icon.vue";
    import {openWindowFromVue} from '../lib/Models/CommonItemsModel';    
    
    const patientSecurityLevel = ref<boolean>(); 

    const props = withDefaults(defineProps<{
            patientID: number,
            patientFullName: string,
            birthDate?: NoTzDate,
            gender?: string,
            patientAddress?: string,
            patientCity?: string,
            patientState?: string,
            patientZipcode?: string,
            homePhone?: string,
            workPhone?: string,
            otherPhone?: string,
            primaryInsuranceData?: string,
            secondaryInsuranceData?: string,
        }>(), { 
    });

    onMounted(async () => {
        const screenJson = await getScreenInfo(AppScreens.PatientSetup); 
        patientSecurityLevel.value = ((screenJson?.security ?? PrivilegeType.None) > PrivilegeType.None);
    });

    function openPatient(mouseClickEvent : MouseEvent) : void {  
        const patientURL = `/officemd/screens/WindowSetup.htm?WT=Patient Setup&Qualifier=patient&WindowID=${props.patientID}&tab=Demographics`;
        openWindowFromVue("NewPatient", patientURL,{ noTimestamp: "Y" });
    }
</script>
<style scoped> 
    .patient-block {
        background-color: white;
        color: black;
        border: none;
        padding: 5px;
    }
</style>
<template>
    <div class="patient-block rounded"> 
        <table style="table-layout: fixed; width: 100%;">
            <colgroup><col style="width: 20%"><col style="width: 30%"><col style="width: 50%"><col style="width: 25px"></colgroup>
            <tr>
                <td colspan="3">
                    <span class="fw-bold fs-6 text-isalus-primary">Patient</span>
                </td>
                <td>  
                    <span v-show="patientSecurityLevel">
                        <Icon 
                            :icon="IconTypes.User" 
                            :displayStyle="DisplayStyle.Primary" 
                            :class="'text-isalus-primary fs-5'" 
                            :title="'Open Patient'" 
                            @click="openPatient"/>                         
                    </span>
                </td>
            </tr> 
            <tr>
                <td colspan="4">
                    <span class="fw-bold label-isalus-small">{{props.patientID}} {{props.patientFullName}}</span>
                    <span class="label-isalus-small ps-1">{{props.birthDate}} {{props.gender}}</span>
                </td>
            </tr>
            <tr>
                <td class="label-isalus-small">Home: {{props.homePhone}}</td>
                <td class="label-isalus-small">{{props.patientAddress}}</td>
                <td colspan="2" class="label-isalus-small">{{props.primaryInsuranceData}}</td>
            </tr>
            <tr>
                <td class="label-isalus-small">Work: {{props.workPhone}}</td>
                <td class="label-isalus-small">{{props.patientCity}}, {{props.patientState}} {{props.patientZipcode}}</td>
                <td class="label-isalus-small">{{props.secondaryInsuranceData}}</td>
            </tr>
            <tr v-if="props.otherPhone">
                <td class="label-isalus-small">Other: {{props.otherPhone}}</td> 
                <td colspan="3">&nbsp;</td>
            </tr>
        </table> 
    </div> 
</template>